import API from '@aws-amplify/api';
import Utils from '@/common/utils/utils';
import Logger from '@/common/utils/Logger';
import { getUserResource } from '@/graphql/queries';
import { editUserResource } from '@/graphql/mutations';

const GET_OR_CREATE_SDESK_TOKEN = 'GET_OR_CREATE_SDESK_TOKEN';
const REGENERATE_SDESK_TOKEN = 'REGENERATE_SDESK_TOKEN';

const normalizeResponse = response => {
    if (!response?.status) {
        return { success: false, data: null, errorCode: response?.error || null };
    }

    const data = Utils.convertJSONDataToObject(response.data) || {};
    return {
        success: true,
        data: {
            ...data,
            token: data.rawToken,
            projectId: data.affiliationProject
        },
        errorCode: null
    };
};

export const getOrCreateToken = async ({ projectId, userId }) => {
    try {
        const response = await API.graphql({
            query: getUserResource,
            variables: {
                getUserResourceRequestDto: {
                    actionFlag: GET_OR_CREATE_SDESK_TOKEN,
                    userId,
                    projectId
                }
            }
        });
        return normalizeResponse(response?.data?.getUserResource);
    } catch (error) {
        Logger.error('sdeskTokenService.getOrCreateToken failed');
        return { success: false, data: null, errorCode: null };
    }
};

export const regenerateToken = async ({ organizationId, projectId, userId }) => {
    try {
        const response = await API.graphql({
            query: editUserResource,
            variables: {
                editUserResourceRequestDto: {
                    actionFlag: REGENERATE_SDESK_TOKEN,
                    corporationId: organizationId,
                    idOfCurrentUser: userId,
                    userId,
                    projectId
                }
            }
        });
        return normalizeResponse(response?.data?.editUserResource);
    } catch (error) {
        Logger.error('sdeskTokenService.regenerateToken failed');
        return { success: false, data: null, errorCode: null };
    }
};
